import React, {useState, useEffect, useContext} from 'react'
import Navbar from '../components/Navbar'
import Categories from '../components/Categories'
import Banner from '../components/Banner'
import CommunityVenturePortfolioBanner from '../components/CommunityVenturePortfolioBanner'
import Blog from '../components/Blog'
import Footer from '../components/Footer'
import Button from '../components/utility/Button'
import { Link, useNavigate } from 'react-router-dom'; // Added useNavigate
import { useApi } from '../context/ApiContext';
// import AuthContext from '../context/AuthContext'

const Home = () => {

  // let { user } = useContext(AuthContext)
  // console.log(user)
  const API_BASE_URL = useApi();
  const [featuredOpportunities, setFeaturedOpportunities] = useState([]);
  
  const [opportunities, setOpportunities] = useState([]);
  const [Otheropportunities, setOtherOpportunities] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [locationFilter, setLocationFilter] = useState('');
  const navigate = useNavigate(); // Initialize navigate

  // Define the base category structure
  const categoriesData = [
    { title: "Open Tenders", key: "tender", icon: "flaticon-tour", link:"/opportunity-listings/tender/", count: 0 },
    { title: "Handy Works (Informal)", key: "handywork", icon: "flaticon-cms", link:"/opportunity-listings/handywork/", count: 0 },
    { title: "Freelance Tasks", key: "freelance", icon: "flaticon-report", link:"/opportunity-listings/freelance/", count: 0 },
    { title: "Internships (Paid / Unpaid)", key: "internship", icon: "flaticon-app", link:"/opportunity-listings/internship/", count: 0 },
    { title: "National Service", key: "national_service", icon: "flaticon-helmet", link:"/opportunity-listings/national_service/", count: 0 },
    { title: "Competitions & Hackathons", key: "competition", icon: "flaticon-high-tech", link:"/opportunity-listings/competition/", count: 0 },
    { title: "Volunteer Positions", key: "volunteer", icon: "flaticon-real-estate", link:"/opportunity-listings/volunteer/", count: 0 },
    { title: "Grants & Research Opportunities", key: "grant", icon: "flaticon-content", link:"/opportunity-listings/grant/", count: 0 },
  ];

  useEffect(() => {
    getOpportunities();
  }, []);

  // Update categories when opportunities change
  useEffect(() => {
    if (opportunities.length > 0) {
      updateCategoryCounts();
    }
  }, [opportunities]);

  const getOpportunities = async () => {
    let fetchUrl = `${API_BASE_URL}/get-opportunities`;
    try {
      let response = await fetch(fetchUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      let data = await response.json();
      if (response.status === 200) {
        setOpportunities(data) 
        let featuredItems = data.filter(item => item.is_featured === true);
        // console.log(featuredItems);
        let notFeaturedItems = data.filter(item => item.is_featured != true);

        // setFeaturedOpportunities(featuredItems);
        setOtherOpportunities(notFeaturedItems); 
        setFeaturedOpportunities(featuredItems);
      } else {
        alert('There is something wrong');
      }
    } catch (error) {
      console.error('Error fetching opportunities:', error);
    }
  };

  const updateCategoryCounts = () => {
    // Create a copy of categoriesData
    const updatedCategories = [...categoriesData];
    
    // Count opportunities for each category
    updatedCategories.forEach(category => {
      const count = opportunities.filter(item => 
        item.opportunityType === category.key
      ).length;
      category.count = count;
    });
    
    // Update state with the counted categories
    setCategories(updatedCategories);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    
    // Navigate to opportunity listings with search parameters
    navigate('/opportunity-listings/all', { 
      state: { 
        searchTerm, 
        locationFilter 
      } 
    });
  };

  const chunkArray = (arr, size) => {
    return Array.from({ length: Math.ceil(arr.length / size) }, (_, index) =>
      arr.slice(index * size, index * size + size)
    );
  };

  return (
    <>
      <Navbar />
      <main>
        {/* <!-- slider Area Start--> */}
        <div className="slider-area ">
          <div className="slider-active">
            <div className="single-slider slider-height d-flex align-items-center" style={{background: "url('../assets/img/hero/my-img.png')", backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover'}} >
              <div className="container">
                <div className="row">
                  <div className="col-xl-6 col-lg-9 col-md-10">
                    <div className="hero__caption">
                      <h1 style={{fontSize: "40px"}}>Find & share opportunities in Africa & Beyond</h1>
                      <h5 style={{fontSize: "17px", marginTop: "-40px"}}><i>Talent is <b>everywhere,</b> but opportunity <b>is not.</b></i></h5>
                    </div>
                  </div>
                </div>
                {/* <!-- Search Box --> */}
                <div className="row">
                  <div className="col-xl-8">
                    {/* <!-- form --> */}
                    <form onSubmit={handleSearch} className="search-box">
                      <div className="input-form">
                        <input 
                          type="text" 
                          placeholder="Job Title or keyword"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>
                      <div className="select-form">
                        <div className="select-itms">
                          <select 
                            style={{
                              width: "100%",
                              border: "none",
                              padding: "24px",
                            //   border: "1px solid #ccc",
                            //   borderRadius: "4px",
                            //   fontSize: "14px",
                            //   backgroundColor: "#fff",
                            //   appearance: "none",
                            //   WebkitAppearance: "none",
                            //   MozAppearance: "none" 
                            }} 
                            value={locationFilter}
                            onChange={(e) => setLocationFilter(e.target.value)}
                          >
                            <option value="">All Locations</option>
                            <option value="Accra">Accra</option>
                            <option value="Kumasi">Kumasi</option>
                            <option value="Takoradi">Takoradi</option>
                            <option value="Cape Coast">Cape Coast</option>
                            <option value="Tamale">Tamale</option>
                            {/* Add more locations as needed */}
                          </select>
                        </div>
                      </div>
                      <div className="search-form">
                        <button className='btn head-btn1' type="submit" style={{cursor: 'pointer', width:'100%',padding: '35px'}}>
                          Search
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- slider Area End--> */}

        {/* <!-- Featured_job_start --> */}
        <section className="py-2 featured-job-area feature-padding">
          <div className="container">
            {/* <!-- Section Tittle --> */}
            <div className="row">
              <div className="col-lg-12">
                <div className="section-tittle text-center">
                  <span>Recent Ads</span>
                  <h2>Featured Listings</h2>
                </div>
              </div>
            </div>
            {chunkArray(featuredOpportunities, 2).map((row, i) => (
              <div className="row justify-content-center" key={i}>
                {row.map(item => (
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" key={item.id}>
                    <div className="single-job-items mb-30">
                      <div className="job-items">
                        <div className="company-img">
                          <Link to={`/opportunity-details/${item.id}/${item.title}`}>
                            <img
                              style={{ maxWidth: '100px', maxHeight: '200px' }}
                              src={item.icon}
                              alt=""
                            />
                          </Link>
                        </div>
                        <div className="job-tittle">
                          <Link to={`/opportunity-details/${item.id}/${item.title}`}>
                            <h6 style={{color:'blue'}}>{item.title}</h6>
                          </Link>
                          <ul>
                            <li style={{ marginRight: '10px' }}>{item.firm}</li>
                            <li>
                              <i className="fas fa-map-marker-alt"></i> Greater Accra, GH
                            </li>
                            <li className="text-success">Confidential</li>
                          </ul>
                        </div>
                      </div>
                      <div className="items-link f-right">
                        <Link to={`/opportunity-details/${item.id}/${item.title}`}>
                          {item.modality}
                        </Link>
                        <span>{item.posted_ago}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
          <Button buttonLabel='More'/>
        </section>
        {/* <!-- Featured_job_end --> */}

         {/* Pass the categories with counts to the Categories component */}
        <Categories categories={categories.length > 0 ? categories : categoriesData} />

        <div className="section-tittle text-center">
          <span>LATEST OPPORTUNITIES</span>
        </div>

        {chunkArray(Otheropportunities, 4).map((row, i) => (
          <div className="row justify-content-center" key={i} style={{ 
            display: 'flex',
            flexWrap: 'wrap'
          }}>
            {row.map(item => (
              <div 
                className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6" 
                key={item.id}
                style={{
                  marginBottom: '15px',
                }}
              >
                <div className="single-job-items" style={{
                  padding: '8px',
                  borderRadius: '6px',
                  background: '#fff',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                  transition: 'all 0.2s ease',
                  width: '100%',
                  position: 'relative',
                  overflow: 'hidden'
                }}>
                  <Link 
                    to={`/opportunity-details/${item.id}/${item.title}`}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <div style={{ 
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                      {/* Logo and Title at top */}
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        marginBottom: '6px',
                        flexShrink: 0
                      }}>
                        <img
                          style={{ width: '28px', height: '28px', objectFit: 'contain', marginRight: '6px' }}
                          src={item.icon}
                          alt=""
                        />
                        <div style={{
                          fontSize: '0.75rem',
                          fontWeight: '600',
                          color: '#2c3e50',
                          lineHeight: '1.2',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box',
                          WebkitLineClamp: '2',
                          WebkitBoxOrient: 'vertical',
                          flex: 1
                        }}>
                          {item.title}
                        </div>
                      </div>

                      {/* Organization name - single line only */}
                      <div style={{
                        fontSize: '0.65rem',
                        color: '#7f8c8d',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        marginBottom: '4px',
                        flexShrink: 0
                      }}>
                        {item.firm}
                      </div>

                      {/* Location and modality in one line */}
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '4px',
                        fontSize: '0.6rem',
                        color: '#95a5a6',
                        flexShrink: 0
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <i className="fas fa-map-marker-alt" style={{ fontSize: '0.55rem', marginRight: '2px' }}></i>
                          <span>{item.location}</span>
                        </div>
                        <div style={{ 
                          backgroundColor: '#f3f9ff',
                          padding: '1px 4px',
                          borderRadius: '3px',
                          color: '#3498db',
                          whiteSpace: 'nowrap'
                        }}>
                          {item.modality}
                        </div>
                      </div>

                      {/* Posted date at bottom */}
                      <div style={{ 
                        fontSize: '0.55rem',
                        color: '#bdc3c7',
                        textAlign: 'right',
                        flexShrink: 0
                      }}>
                        {item.posted_ago}
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ))}

       
        
        <CommunityVenturePortfolioBanner/>

        

        {/* Rest of your component remains the same */}
        {/* <!-- How  Apply Process Start--> */}
        <div className="apply-process-area apply-bg pt-150 pb-150" style={{background: "url('../assets/img/gallery/how-applybg.png')", backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover'}} >
          <div className="container">
            {/* <!-- Section Tittle --> */}
            <div className="row">
              <div className="col-lg-12">
                <div className="section-tittle white-text text-center">
                  <span>Apply process</span>
                  <h2> How it works</h2>
                </div>
              </div>
            </div>
            {/* <!-- Apply Process Caption --> */}
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="single-process text-center mb-30">
                  <div className="process-ion">
                    <span className="flaticon-search"></span>
                  </div>
                  <div className="process-cap">
                    <h5>1. Search a job</h5>
                    <p>Browse through thousands of job opportunities by role, company, or location to find the one that fits you best.</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-process text-center mb-30">
                  <div className="process-ion">
                    <span className="flaticon-curriculum-vitae"></span>
                  </div>
                  <div className="process-cap">
                    <h5>2. Apply for job</h5>
                    <p>Submit your application quickly and easily with just a few clicks, directly through our platform</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-process text-center mb-30">
                  <div className="process-ion">
                    <span className="flaticon-tour"></span>
                  </div>
                  <div className="process-cap">
                    <h5>3. Get your job</h5>
                    <p>Receive interview invitations, secure your offer, and start your new career journey with confidence.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- How  Apply Process End--> */}
        
        <Footer />
      </main>
    </>
  );
}

export default Home;